import { render, staticRenderFns } from "./jput-view.vue?vue&type=template&id=542d6ce2&scoped=true&"
import script from "./jput-view.vue?vue&type=script&lang=js&"
export * from "./jput-view.vue?vue&type=script&lang=js&"
import style0 from "./jput-view.vue?vue&type=style&index=0&id=542d6ce2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "542d6ce2",
  null
  
)

export default component.exports